import PropTypes from "prop-types";
import React from 'react';
import SvgIcon from "../../svg-icon/svg-icon";

import {
  Root,
  ListItem,
  ItemText
} from "./styled";

const FooterPopup = ({ isOpen, options }) => {
  if (isOpen) {
    return (
      <>
        <Root>
          {options.map((option) => {
            const optionKey = `${option.title}_${option.description}`;
            return (
              <ListItem
                key={optionKey}
                onClick={() => option.onClickHandler()}
                disabled={option.disabled}
              >
                <SvgIcon icon={option.icon} />
                <ItemText large>
                  {option.title}
                  {option.description && (
                    <>
                      <br />
                      <ItemText small>
                        {option.description}
                      </ItemText>
                    </>
                  )}
                </ItemText>
              </ListItem>
            )
          })}
        </Root>
      </>
    )
  }

  return null;
}

FooterPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.any,
    title: PropTypes.string,
    description: PropTypes.string,
    onClickHandler: PropTypes.func,
    disabled: PropTypes.bool
  })).isRequired
}

export default FooterPopup;